import { render, staticRenderFns } from "./CabinetDashboard.vue?vue&type=template&id=4a016ed9"
import script from "./CabinetDashboard.vue?vue&type=script&lang=js"
export * from "./CabinetDashboard.vue?vue&type=script&lang=js"
import style0 from "./CabinetDashboard.vue?vue&type=style&index=0&id=4a016ed9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports